import React, { useDeferredValue, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Spin, Table, Typography } from 'antd';
import { useAppMessage } from '../../../hooks/useAppMessage';
import TableEmptyContent from '../../../Components/TableEmptyContent/TableEmptyContent';
import { USERMANAGEMENT_COLUMNS_HEAD } from './UserManagementUtils';
import AdminHeaderTab from '../../../Components/headerTab/AdminHeaderTab';
import AddEmployees from '../../../Components/modals/AddEmployees';
import { UserManagementAPI } from '../../../API/admin/UserManagementAPI';
import ViewTempPass from '../../../Components/modals/ViewTempPass';
import EditEmployee from '../../../Components/modals/EditEmployee';
const { Text } = Typography;

function UserManagement() {
    const [messageApi, contextHolder] = useAppMessage();
    const [spinning, setSpinning] = useState(false)
    const [addEmployeeModal, setAddEmployeeModal] = useState(false)
    const [emplyeeList, setEmployeeList] = useState([])
    const [serachVal, setSearchVal] = useState('');
    const [tempModel, setTempModal] = useState(false);
    const [defualtData, setDefualtData] = useState([]);
    const [tempData, setTempData] = useState({ firstName: '', lastName: '', pass: '' });
    const [editEmployeeModal, setEditEmployeeModal] = useState(false);
    const [editData, setEditData] = useState({ firstName: '', lastName: '', email: '', user: '' })

    const deferredQuery = useDeferredValue(serachVal);
    useEffect(() => {
        serachFun()
    }, [deferredQuery]);

    async function loadConfigData() {
        setSpinning(true)
        await UserManagementAPI.getUserList()
            .then(res => {
                if (res.data.status === true) {
                    const arr = res.data?.data.map((ele, index) => ({ ...ele, serial_no: index + 1 }))
                    setDefualtData(arr)
                    setEmployeeList(arr)
                } else {
                    messageToast('error', res.data?.message);
                }
            })
            .catch(() => messageToast('error', "Internal Server Error"))
            .finally(() => setSpinning(false))
    }

    async function confirmDelete(ele) {
        const bodyData = {
            email: ele?.email
        }
        setSpinning(true)
        await UserManagementAPI.deleteUserPost(bodyData)
            .then(res => {
                if (res.data.status === true) {
                    messageToast('success', res.data?.message);
                    loadConfigData();
                } else {
                    messageToast('error', res.data?.message);
                }
            })
            .catch(() => messageToast('error', "Internal Server Error"))
            .finally(() => setSpinning(false))

    }

    function viewTemp(ele) {
        setTempData({
            firstName: ele?.first_name, lastName: ele?.last_name, pass: ele?.temp_pass
        })
        setTempModal(true)
    }

    async function generateTempPass(ele) {
        const bodyData = {
            email: ele?.email
        }
        setSpinning(true)
        await UserManagementAPI.regenerateTempPass(bodyData)
            .then(res => {
                if (res.data.status === false) {
                    messageToast('success', res.data?.message);
                    loadConfigData();
                } else {
                    messageToast('error', res.data?.message);
                }
            })
            .catch(() => messageToast('error', "Internal Server Error"))
            .finally(() => setSpinning(false))
    }

    function editUserFun(ele) {
        setEditData({ firstName: ele?.first_name, lastName: ele?.last_name, email: ele?.email, user: ele?.group[0] })
        setEditEmployeeModal(true)
    }

    function serachFun() {
        let arr = [...defualtData];
        const filterArr = arr.filter((ele) => {
            return (
                (!serachVal.trim() || String(`${ele.first_name} ${ele.last_name}`).toLowerCase().includes(serachVal.trim().toLowerCase()))
            )
        })
        setEmployeeList(filterArr)
    }

    useEffect(() => {
        loadConfigData()
    }, [])


    const messageToast = (type, message) => {
        messageApi.open({
            type: type,
            content: message,
            duration: 6,
        });
    };

    return (
        <div className='container_div'>
            <Helmet>
                <title>SpecOptimizer | Admin</title>
            </Helmet>

            <AdminHeaderTab currrentTab='User Management' />

            <div className='admin_tab_content_wraper'>
                <Spin spinning={spinning}>
                    <div className='table_head_wraper'>
                        <Text className='table_head' >User Management</Text>
                        <div className='table_custom_buttons'>
                            <div
                                style={{
                                    borderRadius: '25px',
                                    backgroundColor: '#EBEEF8',
                                    color: '#737373',
                                    display: 'flex',
                                    marginRight: '10px',
                                    flex: '1 1 0px '
                                }}
                            >
                                <input value={serachVal} onChange={(e) => setSearchVal(e.target.value)} className='searc_input' />
                                <SearchOutlined className='search_btn' style={{ color: !serachVal ? '#737373' : '#ff4d4f', fontSize: '18px', padding: '10px', borderRadius: '6px', }} />
                            </div>
                            <Button type='primary' icon={<PlusOutlined />} onClick={() => setAddEmployeeModal(true)}>Add New</Button>
                        </div>
                    </div>

                    <div>
                        <Table
                            rowKey="serial_no"
                            columns={USERMANAGEMENT_COLUMNS_HEAD(confirmDelete, viewTemp, editUserFun, generateTempPass)}
                            dataSource={emplyeeList}
                            pagination={{
                                pageSize: 10,
                                responsive: true,
                                hideOnSinglePage: true
                            }}
                            style={{ marginTop: '20px', }}
                            className='antdTable'
                            locale={{
                                emptyText: <TableEmptyContent />,
                            }}
                        />
                    </div>
                </Spin>
            </div>

            <AddEmployees
                open={addEmployeeModal}
                setOpen={setAddEmployeeModal}
                messageToast={messageToast}
                setTempModal={setTempModal}
                setTempData={setTempData}
                loadConfigData={loadConfigData}
            />
            <EditEmployee
                open={editEmployeeModal}
                setOpen={setEditEmployeeModal}
                messageToast={messageToast}
                loadConfigData={loadConfigData}
                editData={editData}
            />
            <ViewTempPass open={tempModel} setOpen={setTempModal} tempData={tempData} />

            {contextHolder}
        </div >
    )
}

export default UserManagement